import { IMessagingService } from "../services";
import { Component } from "./component";



interface IFocusableElement {
    focus(): void;
}

function isFocusable(element: any): element is IFocusableElement {
    return (typeof element.focus === "function");
}

function getKeyboardFocusableElements(element) {
    return [...element.querySelectorAll(
        'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
    )].filter(el => !el.hasAttribute('disabled') && !el.getAttribute("aria-hidden"));
}

class VideoComponent extends Component {
    private id: string;
    private ytPlayer: YT.Player;
    private overlay: HTMLElement;
    private iframePlayer: HTMLIFrameElement;
    private playBtn: HTMLElement;
    private closePlayerLink: HTMLElement;
    private isShowing: boolean;
    private firstFocusTargetEl: HTMLElement;
    private focusableEls: any[];
    private priorFocusedEl: any;
    private videoComponent: HTMLElement;
    private PlayerReady: YT.PlayerEventHandler<YT.PlayerEvent>;
    private KeyDownHandlerForCloseVideoControls: EventListener;
    private PlayerStateChange: YT.PlayerEventHandler<YT.PlayerEvent>;
    private KeyDownHandlerForPlayButton: EventListener;
    private ClickHandlerForPlayButton: EventListener;
    private ClickHandlerForCloseVideoControls: EventListener;
    private BlurEvent: EventListener;



    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        //this can be run from the YT script or as part of startup, so guard against double runs
        if (componentEl.classList.contains('video-component-loaded')) {
            return;
        }

        this.iframePlayer = componentEl.getElementsByTagName("iframe")[0];
        this.overlay = componentEl.querySelector<HTMLElement>('.video-overlay');
        this.playBtn = componentEl.querySelector<HTMLElement>('.videoplaybtn');
        this.closePlayerLink = (componentEl.querySelector<HTMLElement>('.closeplayerlink') as HTMLElement | null);
        this.videoComponent = componentEl;
        this.id = componentEl.dataset.id;
        // Get focus target element
        this.firstFocusTargetEl = componentEl.querySelector<HTMLElement>('*[tabindex="-1"]');
        // Get focusable elements
        this.focusableEls = getKeyboardFocusableElements(componentEl);
        this.init();


    }

    protected async init() {
        this.isShowing = false;

        // Events
        

        this.KeyDownHandlerForCloseVideoControls = this.onKeyDownHandlerForCloseVideoControls.bind(this);
        this.KeyDownHandlerForPlayButton = this.onKeyDownHandlerForPlayButton.bind(this);
        this.ClickHandlerForPlayButton = this.onClickHandlerForPlayButton.bind(this);
        this.ClickHandlerForCloseVideoControls = this.onClickHandlerForCloseVideoControls.bind(this);
        this.BlurEvent = this.onBlur.bind(this);
        this.PlayerStateChange = this.onPlayerStateChange.bind(this);

        this.iframePlayer.addEventListener("keydown", this.KeyDownHandlerForCloseVideoControls);
        this.iframePlayer.addEventListener("click", this.ClickHandlerForCloseVideoControls);

        if (this.overlay != null) {
            this.overlay.addEventListener("keydown", this.KeyDownHandlerForCloseVideoControls);
            this.overlay.addEventListener("click", this.ClickHandlerForCloseVideoControls);
        }

        if (this.closePlayerLink != null) {
            this.closePlayerLink.addEventListener("click", this.ClickHandlerForCloseVideoControls);
            this.closePlayerLink.addEventListener("keydown", this.KeyDownHandlerForCloseVideoControls);
        }
        this.playBtn.addEventListener("click", this.ClickHandlerForPlayButton);
        this.playBtn.addEventListener("keydown", this.KeyDownHandlerForPlayButton);

        // Get prior focused element
        this.priorFocusedEl = document.activeElement;
        //this.priorFocusedEl.addEventListener("blur", this.BlurEvent);
        this.createPlayerInstance();

        this.videoComponent.classList.add('video-component-loaded');
    }

    private createPlayerInstance() {
        this.ytPlayer = new YT.Player(this.iframePlayer.id, {});
        this.ytPlayer.addEventListener("onStateChange", this.PlayerStateChange);
        this.ytPlayer.addEventListener("onReady", this.PlayerReady);
        this.iframePlayer = this.ytPlayer.getIframe();
        //this.iframePlayer.contentWindow.document.addEventListener("blur", this.BlurEvent);
        //this.iframePlayer.addEventListener("blur", this.BlurEvent);

    }

    private onPlayerReady(event) {
        //reserved for future use
    }

    private onBlur(event) {
         //reserved for future use
    }

    private onPlayerStateChange(event: YT.PlayerEvent) {
        if (event.target.getPlayerState() == 0) {
            //playback has ended, so hide the player and overlay

            this.stopVideoAndCloseOverlay();
        }
    }

    private onClickHandlerForPlayButton(e) {
        this.showOverlayAndPlayVideo();
       
    }

    private onKeyDownHandlerForPlayButton(e) {
        if (e.which == 13) {
            // enter
            this.showOverlayAndPlayVideo();
        }
    }

    private onClickHandlerForCloseVideoControls(e) {
        this.stopVideoAndCloseOverlay();
    }

    private onKeyDownHandlerForCloseVideoControls(e) {
        if (e.which == 27) {
            // alert('Esc pressed');
            this.stopVideoAndCloseOverlay();
        }
    }


    private stopVideoAndCloseOverlay() {
        this.ytPlayer.stopVideo();
        if (this.overlay != null) {
            this.hideOverlay();
            this.playBtn.focus();
        }
        else {
            this.iframePlayer.classList.add('hidden');
        }
    }

   private showOverlayAndPlayVideo() {
        if (this.overlay != null) {
            this.showOverlay();
            this.ytPlayer.playVideo();
            
                this.iframePlayer.focus();
          
        }
        else {
            this.iframePlayer.classList.remove('hidden');
            this.ytPlayer.playVideo();
        }
    }
    private resize() {
        //reserved for future functionality
    }

    private onResizeHandler() {
        this.resize();
    }

    public showOverlay() {
        this.overlay.classList.add('showoverlay');


        setTimeout(() => {
            this.isShowing = true;
            this.overlay.focus();
            //if (this.firstFocusTargetEl) {
            //    this.firstFocusTargetEl.focus();
            //}
        }, 200);
    }

    public hideOverlay() {

        this.overlay.classList.remove('showoverlay');

        if (this.closePlayerLink != null) {
            this.closePlayerLink.removeEventListener("click", this.onClickHandlerForCloseVideoControls);
        }

        this.iframePlayer.removeEventListener("keydown", this.onKeyDownHandlerForCloseVideoControls);
        this.iframePlayer.removeEventListener("click", this.onClickHandlerForCloseVideoControls);
        this.playBtn.removeEventListener("click", this.onClickHandlerForPlayButton);
        this.playBtn.removeEventListener("keydown", this.onKeyDownHandlerForPlayButton);


        setTimeout(() => {
            //           this.overlay.parentNode.removeChild(this.overlay);
            this.isShowing = false;
            return;
            //reserved for future use
            if (this.priorFocusedEl.tagName === "BODY" || this.priorFocusedEl.tagName === "MAIN") {
                if (!document.body.getAttribute("tabindex")) {
                    document.body.setAttribute("tabindex", "-1");
                    document.body.focus();
                    document.body.removeAttribute("tabindex");
                } else {
                    document.body.focus();
                }
            } else if (this.priorFocusedEl && isFocusable(this.priorFocusedEl)) {
                this.priorFocusedEl.focus();
            }

        }, 200);

        return this;
    }
}

export { VideoComponent };
